module.exports = __webpack_public_path__ + "static/media/homepage_curriculum_banner.8edd71d5.jpg";